"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Minter = void 0;

var _constants = require("./constants");

var _types = require("./types");

var _files = require("./utils/files");

var _storage = require("./utils/storage");

var _responseBuilder = require("./utils/responseBuilder");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * A programmatic metadata generator.
 */


var Minter = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function Minter() {
    var minterConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Minter);

    _defineProperty(this, "latestMints", void 0);

    _defineProperty(this, "currentMint", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "apiKey", void 0);

    _defineProperty(this, "constants", void 0);

    this.latestMints = {};
    this.currentMint = {};
    this.constants = minterConfig.constants || {};
    this.apiKey = minterConfig.apiKey || 'anonymous';
    this.storage = new _storage.Storage({
      apiKey: this.apiKey,
      constants: this.constants
    });
  }
  /**
   * Uploads the current metadata object and returns its content identifier.
   */


  _createClass(Minter, [{
    key: "getMetadataId",
    value: function () {
      var _getMetadataId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$storage$u, uploadResult, error, id;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.currentMint && Object.keys(this.currentMint).length === 0 && this.currentMint.constructor === Object)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.metadataEmpty
                }));

              case 2:
                if (this.storage) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Storage not initialized'
                }));

              case 4:
                _context.next = 6;
                return this.storage.uploadMetadata(this.currentMint);

              case 6:
                _yield$this$storage$u = _context.sent;
                uploadResult = _yield$this$storage$u.data;
                error = _yield$this$storage$u.error;

                if (!error) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 11:
                id = uploadResult.id;
                this.latestMints = _objectSpread(_objectSpread({}, this.latestMints), {}, _defineProperty({}, id, this.currentMint));
                this.currentMint = {};
                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: id
                }));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMetadataId() {
        return _getMetadataId.apply(this, arguments);
      }

      return getMetadataId;
    }()
    /**
     * Set a field in metadata.
     * @param key The field key.
     * @param value The field value.
     */

  }, {
    key: "setField",
    value: function setField(key, value, override) {
      try {
        this.fieldChecks(key, value);
      } catch (error) {
        return (0, _responseBuilder.formatResponse)({
          error: error.message
        });
      }

      if (!this.currentMint[key]) this.currentMint[key] = value;else if (override && !!this.currentMint[key]) this.currentMint[key] = value;
      return (0, _responseBuilder.formatResponse)({
        data: true
      });
    }
  }, {
    key: "setMetadata",
    value: function setMetadata(metadata, override) {
      var _this = this;

      try {
        Object.keys(metadata).forEach(function (field) {
          _this.setField(field, metadata[field], override);
        });
        return (0, _responseBuilder.formatResponse)({
          data: true
        });
      } catch (error) {
        return (0, _responseBuilder.formatResponse)({
          error: error.message
        });
      }
    }
    /**
     * Uploads file and sets its corresponding URI to a field.
     * @param field The metadata field.
     * @param file The file to upload.
     */

  }, {
    key: "uploadField",
    value: function () {
      var _uploadField = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(field, file) {
        var _VALID_FILE_FORMATS$f;

        var _yield$this$upload, data, error, uri, hash, _determineUploadMetad, keyHash, keyUrl;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_VALID_FILE_FORMATS$f = _constants.VALID_FILE_FORMATS[field]) !== null && _VALID_FILE_FORMATS$f !== void 0 && _VALID_FILE_FORMATS$f.includes(file.type)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.fileTypeNotAccepted
                }));

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this.upload(file);

              case 5:
                _yield$this$upload = _context2.sent;
                data = _yield$this$upload.data;
                error = _yield$this$upload.error;

                if (!error) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadFileAndSet
                }));

              case 10:
                uri = data.uri, hash = data.hash;
                _determineUploadMetad = _determineUploadMetadataFields(field), keyHash = _determineUploadMetad.hash, keyUrl = _determineUploadMetad.url;

                if (keyHash && keyUrl) {
                  this.currentMint[keyUrl] = uri;
                  this.currentMint[keyHash] = hash;
                } else {
                  this.currentMint[field] = uri;
                  this.currentMint["".concat(field, "_hash")] = hash;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadFileAndSet
                }));

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 16]]);
      }));

      function uploadField(_x, _x2) {
        return _uploadField.apply(this, arguments);
      }

      return uploadField;
    }()
    /**
     * Uploads file and returns corresponding URI.
     * @param file The file to upload.
     */

  }, {
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
        var tFile, _yield$this$storage$u2, result, error, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (this.storage) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Storage not initialized'
                }));

              case 3:
                _context3.next = 5;
                return (0, _files.correctFileType)(file);

              case 5:
                tFile = _context3.sent;

                if (tFile.size > (this.constants.FILE_UPLOAD_SIZE_LIMIT || _constants.FILE_UPLOAD_SIZE_LIMIT)) {
                  (0, _responseBuilder.formatResponse)({
                    error: 'Storage not initialized'
                  });
                }

                _context3.next = 9;
                return this.storage.uploadToArweave(file);

              case 9:
                _yield$this$storage$u2 = _context3.sent;
                result = _yield$this$storage$u2.data;
                error = _yield$this$storage$u2.error;

                if (!(!result || error)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 14:
                data = {
                  uri: "".concat(this.constants.BASE_ARWEAVE_URI || _constants.BASE_ARWEAVE_URI, "/").concat(result === null || result === void 0 ? void 0 : result.id),
                  hash: result === null || result === void 0 ? void 0 : result.id
                };
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _context3.t0.message
                }));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18]]);
      }));

      function upload(_x3) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }() // TODO: implement all checks

  }, {
    key: "fieldChecks",
    value: function fieldChecks(key, value) {
      switch (key) {
        case _types.MetadataField.Media:
          if (typeof value !== 'string') throw new Error(_constants.ERROR_MESSAGES.notString);
          if (!value.match(_constants.REGEX_URL)) throw new Error(_constants.ERROR_MESSAGES.badUrl);
          break;

        case _types.MetadataField.Title:
          if (typeof value !== 'string') throw new Error(_constants.ERROR_MESSAGES.notString);
          break;

        case _types.MetadataField.Description:
          if (typeof value !== 'string') throw new Error(_constants.ERROR_MESSAGES.notString);
          break;

        default:
          break;
      }
    }
  }]);

  return Minter;
}();

exports.Minter = Minter;

var _determineUploadMetadataFields = function _determineUploadMetadataFields(type) {
  switch (type) {
    case _types.MetadataField.Media:
    case _types.MetadataField.Media_hash:
      return {
        url: _types.MetadataField.Media,
        hash: _types.MetadataField.Media_hash
      };

    case _types.MetadataField.Animation_url:
    case _types.MetadataField.Animation_hash:
      return {
        url: _types.MetadataField.Animation_url,
        hash: _types.MetadataField.Animation_hash
      };

    default:
      return {
        url: null,
        hash: null
      };
  }
};